import React from "react";
import PropTypes from "prop-types";
import { RiCloseLine, RiLock2Line } from "react-icons/ri";

const CartOverlayHeader = ({ itemCount, onClose }) => {
  return (
    <div
      className="flex items-center justify-between px-8 md:!px-16 py-4 z-50"
      style={{
        borderBottom: "1px solid #e2e2e2",
      }}
    >
      <h2 className="text-[20px] mt-3 font-light tracking-wide text-black">
        Cart({itemCount})
      </h2>

      <div
        className="flex items-center gap-4"
        style={{
          visibility: "hidden",
        }}
      >
        <div className="relative">
          <RiLock2Line className="h-6 w-6 text-black" />
          <span className="absolute -top-2 left-1/2 -translate-x-1/2 h-5 min-w-5 px-1 border border-black bg-white text-[12px] leading-none font-mono flex items-center justify-center">
            {itemCount}
          </span>
        </div>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close cart"
          className=" text-black hover:opacity-70 transition-opacity"
        >
          <RiCloseLine className="w-7 h-7" />
        </button>
      </div>
    </div>
  );
};

CartOverlayHeader.propTypes = {
  itemCount: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CartOverlayHeader;
